import {
  Options,
  SeriesLegendItemClickCallbackFunction,
  SeriesLegendItemClickEventObject,
} from 'highcharts';
import moment from 'moment-timezone';

const commonOptions = (): Options => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const primaryColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-primary');
  const mediumColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-medium');
  const defaultFontFamily = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-font-family');

  return {
    accessibility: {
      enabled: false,
    },
    chart: {
      backgroundColor: 'transparent',
      spacing: [10, 5, 0, 5],
      style: {
        fontFamily: defaultFontFamily,
      },
      animation: false,
    },
    title: {
      text: undefined,
    },
    tooltip: {
      xDateFormat: `%b %e - %l:%M%P, ${moment.tz(timezone).zoneAbbr()}`,
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%b %e',
        hour: '%l%P',
        minute: '%l:%M%P',
      },
      tickPixelInterval: 50,
      tickLength: 5,
    },
    yAxis: {
      title: undefined,
      tickLength: 5,
    },
    legend: {
      margin: 2,
      symbolPadding: 2,
      navigation: {
        activeColor: primaryColor,
        inactiveColor: mediumColor,
        style: {
          color: primaryColor,
        },
      },
    },
    credits: {
      enabled: false,
    },
    time: {
      timezone,
      moment,
    },
  };
};

const legendItemClick: SeriesLegendItemClickCallbackFunction = (
  e: SeriesLegendItemClickEventObject
): boolean => {
  const chart = e.target.chart;
  let allOn = false;
  let justOneOn = false;
  const seriesOn: number[] = [];
  const seriesVisibility: boolean[] = [];

  chart.series.map((series, index): boolean => {
    if (series.visible) seriesOn.push(index);
    seriesVisibility.push(series.visible);
    return true;
  });
  if (seriesOn.length === chart.series.length) allOn = true;
  if (seriesOn.length === 1) justOneOn = true;

  const seriesLength = chart.series.length;
  for (let index = 0; index < seriesLength; index++) {
    if (justOneOn && seriesVisibility[e.target.index]) {
      chart.series[index].setVisible(true, false);
    } else if (index === e.target.index) {
      chart.series[index].setVisible(
        allOn ? true : !seriesVisibility[index],
        false
      );
    } else if (allOn) {
      chart.series[index].setVisible(false, false);
    } else if (seriesVisibility[index] && justOneOn) {
      chart.series[index].setVisible(true, false);
    }
  }
  chart.redraw();
  return false;
};

export { commonOptions, legendItemClick };
